<template>
  <div class="modal" @click.self="$emit('close')">
    <div class="modal-content">
      <h3>Практическая часть обучения</h3>

      <p>Уважаемый слушатель Вы успешно завершили теоретическую часть обучения.</p>
      <p>
        Следующий этап - практическая часть, которую Вы проходите ОЧНО с преподавателем!
        Следуйте указаниям ответственного за обучения Вашей организации и Куратора от
        АНО ДПО «ПРАВО», которые направят Вас на прохождение практической части обучения.
        Скачайте предоставленный здесь Лист практических занятий и предоставьте ее преподавателю.
        По завершению практической части и получении отметки о её прохождении, поставьте
        в Лист практических занятий дату и подпись.
      </p>

      <a v-if="practiceSheetUrl"
         :href="practiceSheetUrl"
         target="_blank"
         class="btn btn-secondary btn-modal">
        Скачать Лист практических занятий
      </a>

      <button type="button" class="btn btn-secondary btn-modal" @click="$emit('close')">Понятно</button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    /** Ссылка на Лист практических занятий. Пусто — кнопка скачивания не показывается. */
    practiceSheetUrl: {
      type: String,
      default: ''
    }
  }
};
</script>

<style scoped>
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}

.modal-content {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  width: 90%;
  max-width: 640px;
  max-height: 90vh;
  overflow-y: auto;
  text-align: left;
}

.modal-content h3 {
  margin-bottom: 1rem;
}

.modal-content p {
  margin-bottom: 0.75rem;
}

.btn {
  padding: 5px 10px;
  cursor: pointer;
  border: none;
  border-radius: 4px;
}

.btn-secondary {
  background-color: rgb(248, 108, 1);
  color: white;
}

a.btn-secondary {
  display: inline-block;
  text-decoration: none;
}

.btn-modal {
  margin-top: 5px;
  margin-right: 5px;
}
</style>
